import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from '@nextui-org/react';
import { OrderDetails } from '../../data/types/orders';
import { Package } from '../../data/types/shipping';
import { useState } from 'react';
import { PackageCard } from './package_editing_modal_components';
import { PopupWithConfirmation } from '../popups';

export function PackageEditingModal({
  open,
  headerTitle = 'Title',
  bodyText = 'To make it easier for couriers to identitfy the order and for you, use the Labels ID paper we sent you to label this order with a BARCODE so you can easily track it in the future. To add a package enter the label ID manually below or press the camera icon to scan. To add a package enter the label ID manually below or press the camera icon to scan',
  buttonOneText = 'Cancel',
  buttonTwoText = 'Submit',
  onButtonOneClick,
  onButtonTwoClick,
  orderDetails,
  confirmAction = false,
}: {
  open: boolean;
  headerTitle?: string;
  bodyText?: string;
  buttonOneText?: string;
  buttonTwoText?: string;
  onButtonOneClick?: any;
  // eslint-disable-next-line no-undef
  onButtonTwoClick: (packages: Package[]) => void;
  orderDetails: OrderDetails;
  confirmAction?: boolean;
}) {
  const [showConfirmation, setShowConfirmation] = useState(
    false && confirmAction,
  );
  const { isOpen, onOpenChange, onClose } = useDisclosure({
    isOpen: open,
    onClose: onButtonOneClick,
  });

  const [currentPackages, setCurrentPackages] = useState(
    orderDetails?.shipments[0]?.packages ?? [],
  );

  return (
    <>
      <PopupWithConfirmation
        open={showConfirmation}
        headerTitle={headerTitle + '?'}
        bodyText="Are you sure you want to continue?"
        buttonOneText="No"
        buttonTwoText="Yes"
        onButtonOneClick={() => {
          setShowConfirmation(false);
        }}
        onButtonTwoClick={() => {
          setShowConfirmation(false);
          onButtonTwoClick(currentPackages);
        }}
      />
      <Modal
        backdrop="opaque"
        isOpen={isOpen}
        onClose={onClose}
        isDismissable={false}
        onOpenChange={onOpenChange}
        classNames={{
          backdrop:
            'bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20',
        }}
        size="5xl"
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                {headerTitle}
              </ModalHeader>
              <ModalBody className="mt-2">
                <p> {bodyText}</p>
                <div
                  className="scrollable  flex-row items-center"
                  style={{
                    margin: 0,
                    padding: 0,
                    gap: 'var(--lg)', // Assuming you have a variable --lg defined
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    display: 'flex',
                    overflowX: 'auto',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                  }}
                >
                  {currentPackages.map((pkg) => (
                    <PackageCard
                      key={pkg.tracking_code}
                      packageData={pkg}
                      setPackageData={(pkg, oldId) => {
                        setCurrentPackages(
                          currentPackages.map((p) =>
                            p.tracking_code === oldId ? pkg : p,
                          ),
                        );
                      }}
                      removePackage={(pkg) => {
                        setCurrentPackages(
                          currentPackages.filter((p) => p !== pkg),
                        );
                      }}
                    />
                  ))}{' '}
                  <PackageCard
                    key={Math.random().toString(16).slice(2)}
                    addPackage={(pkg) => {
                      setCurrentPackages([...currentPackages, pkg]);
                    }}
                    removePackage={(pkg) => {
                      setCurrentPackages(
                        currentPackages.filter(
                          (p) => p.tracking_code !== pkg.tracking_code,
                        ),
                      );
                    }}
                  />
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="default"
                  variant="light"
                  onPress={() => {
                    onButtonOneClick();
                    onClose();
                  }}
                >
                  {buttonOneText}
                </Button>
                <Button
                  variant="ghost"
                  color="danger"
                  onPress={async () => {
                    if (confirmAction) {
                      setShowConfirmation(true);
                    } else {
                      onButtonTwoClick(currentPackages);
                    }
                  }}
                >
                  {buttonTwoText}
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
